/**
 * Custom BS5 Lightbox Instance:
 * - Workaround to use with dynamically loaded images ({@link https://github.com/trvswgnr/bs5-lightbox/issues/15}).
 * - Workaround to work with boostrap 5.2+ ({@link https://github.com/trvswgnr/bs5-lightbox/issues/62}.
 * - Integration with Gutenberg image and gallery block {@link project://inc/}.
 *
 * See BS5 Lightbox documentation at {@link https://trvswgnr.github.io/bs5-lightbox/}
 *
 * @author MNCA
 */

import Lightbox from "./bs5-lightbox";

export default () => {
    document.querySelectorAll(Lightbox.defaultSelector).forEach(el => el.removeEventListener('click', Lightbox.initialize));

    const options = {
        interval: 10000 // `false` is not anymore a valid value with BS 5.2.x for data-bs-interval html attribute.
    };

    document.addEventListener('click', event => {
        const target = event.target.closest('[data-toggle="bs5-lightbox"]');

        if (target) {
            event.preventDefault();
            const lightbox = new Lightbox(target, options);
            lightbox.show();
        }
    });
};
